import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal } from "../components/Reveal";
import { FAQS } from "../data/content";

export const FaqSection = ({ items = FAQS, title, eyebrow = "Häufige Fragen" }) => (
  <section className="bg-white py-24 sm:py-32 border-t border-slate-100" data-testid="faq-section">
    <div className="max-w-[1100px] mx-auto px-6 sm:px-10">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <p className="text-xs uppercase tracking-[0.25em] text-blue-700 mb-5">{eyebrow}</p>
          <h2 className="text-4xl sm:text-5xl font-heading font-semibold tracking-tight text-navy-900 leading-[1.05] lg:sticky lg:top-28">
            {title || <>Alles, was Sie <span className="font-serif italic text-blue-700">wissen</span> müssen.</>}
          </h2>
        </div>
        <div className="lg:col-span-8">
          <Reveal>
            <Accordion type="single" collapsible className="w-full">
              {items.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left text-lg font-heading font-normal text-navy-900 hover:text-blue-700 py-6 hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-500 leading-relaxed text-base pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
